import { IconProps } from '../../Interfaces/Props';

const IconNodeOption = (props: IconProps) => {
  return (
    <>
      <svg
        width={props.size || 18}
        height={props.size || 18}
        className={props.className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        style={props.style}
      >
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M23 20V6H6v14zm19 22V28H25v14zM31 6v14h11V6zM6 28v14h11V28z"
        />
      </svg>
    </>
  );
};

export default IconNodeOption;
